import { Dropdown as AntDropdown, type DropDownProps as AntDropdownProps } from "antd/es";
import type React from "react";

export type DropdownProps = React.PropsWithChildren<AntDropdownProps>;

export const Dropdown: React.FC<DropdownProps> = AntDropdown;
